import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useChipiContext } from "../context";
import type { CallAnyContractParams } from "@chipi-stack/types";

type CallAnyContractInput = {
  params: CallAnyContractParams;
  bearerToken: string;
};

/**
 * Hook for calling any contract method
 */
export function useCallAnyContract(): {
  callAnyContract: (params: CallAnyContractInput) => void;
  callAnyContractAsync: (params: CallAnyContractInput) => Promise<string>;
  data: string | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isSuccess: boolean;
  reset: () => void;
} {
  const { chipiSDK } = useChipiContext();

  const mutation: UseMutationResult<string, Error, CallAnyContractInput> =
    useMutation({
      mutationFn: (params: CallAnyContractInput) =>
        chipiSDK.callAnyContract(params),
    });

  return {
    callAnyContract: mutation.mutate,
    callAnyContractAsync: mutation.mutateAsync,
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
